<template>
  <div class="index">
    <!-- 筛选 -->
    <section>
      <el-form class="section-filter" :model="filterForm" :inline="true" label-width="100px">
        <div class="filter-col">
          <!-- <el-form-item label="合同名称：">
            <el-input clearable v-model="filterForm.name" placeholder="请输入合同名称"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="合同名称：">
            <el-input clearable v-model="filterForm.contract.name" placeholder="请输入合同名称"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="起始时间">
            <el-date-picker
              size="mini" type="datetime" default-time="00:00:00" v-model="filterForm.startSalaryMillisecond" :style="'width:200px;'"
              format="yyyy-MM-dd HH:mm:ss" value-format="timestamp" placeholder="选择时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="截止时间">
            <el-date-picker
              size="mini" type="datetime" default-time="00:00:00" v-model="filterForm.endSalaryMillisecond" :style="'width:200px;'"
              format="yyyy-MM-dd HH:mm:ss" value-format="timestamp" placeholder="选择时间"></el-date-picker>
          </el-form-item> -->
        </div>
        <div class="filter-area">
          <div class="filter-area-label">地区：</div>
          <AreaPicker ref="AreaPicker" @getData="filterHandler" level="4" />
        </div>
        <div class="filter-btn">
          <el-button type="primary" @click="filterHandler()" icon="el-icon-search">查询</el-button>
        </div>
      </el-form>
    </section>
    <!-- 用户操作按钮 -->
    <section class="section-btns">
      <el-button type="" icon="el-icon-view" @click="viewHandler" v-if="btnShow.search" :disabled="selectRows.length!==1">查看</el-button>
      <!-- <el-button type="success" icon="el-icon-download" @click="exportHandler()" v-if="btnShow.export">数据导出</el-button> -->
    </section>
    <!-- 数据表格 -->
    <section class="table">
      <el-table :data="tableData" max-height="550" border highlight-current-row @selection-change="checkHandler">
        <!--  @current-change="selectHandler" -->>
        <el-table-column  type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo" :key="i"
          :prop="x.key" :label="x.label" :fixed="x.fixed||false" :align="x.align||'center'"></el-table-column>
      </el-table>
      <Pagenation :pageData="pageData" @pageChange="pageChange"></Pagenation>
    </section>

    <!-- 模态框 查看模式 -->
    <DialogView
      ref="DialogView"
      :dialogTitle="dialogTitle"
      :formItems="formItems"
      :formItems2="formItems2"
      dialogWidth="1000px" />

    <!-- <DownloadByArea ref="DownloadByArea" :xlsCode="xlsCode" /> -->
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import DialogEdit from '@/components/DialogEdit'
import DialogView from '@/components/DialogView'
// import AreaPicker from '@/components/AreaPicker_4'
import AreaPicker from '@/components/AreaPicker'
import Pagenation from '@/components/Pagenation'
import DownloadByArea from '@/components/DownloadByArea'
import mixin_upload from '@/Mixins/mixin_upload'
import mixins from '@/Mixins/mixin_com'
import { powerMap } from '@/publicData/powerData'
export default {
  mixins: [mixins, mixin_upload],
  components: { AreaPicker, DialogView, DialogEdit, Pagenation, DownloadByArea },
  data() {
    return {
      sign: 'report',
      dialogTitle: '个人信息',

      baseInfo: [
        { key: 'province', label: '省' },
        { key: 'city', label: '市' },
        { key: 'county', label: '县' },
        { key: 'town', label: '镇' },
        { key: 'village', label: '村' },
        // { key: 'areaName', label: '地区' },

        { key: 'haveJob', label: '已就业人员' },
        { key: 'noJobNoWish', label: '无就业意愿' },
        { key: 'noJobHaveWish', label: '有就业意向' },
      ],

      formItems: [
        { type: 'text', key: 'haveJob', label: '已就业人员' },
        { type: 'text', key: 'noJobNoWish', label: '无就业意愿' },
        { type: 'text', key: 'noJobHaveWish', label: '有就业意向' },

        { type: 'text', key: 'ageRange18To30', label: '18到30' },
        { type: 'text', key: 'ageRange31To40', label: '31到40' },
        { type: 'text', key: 'ageRange41To50', label: '41到50' },
        { type: 'text', key: 'ageRange51To60', label: '51到60' },
        { type: 'text', key: 'educationHighSchool', label: '高中以下' },
        { type: 'text', key: 'educationSecondary', label: '中专' },
        { type: 'text', key: 'educationUniversity3', label: '专科' },
        { type: 'text', key: 'educationUniversity4', label: '本科' },
        { type: 'text', key: 'educationMaster', label: '硕士及以上' },

        { type: 'text', key: 'jobOranization', label: '单位就业' },
        { type: 'text', key: 'jobFlexible', label: '灵活就业' },
        { type: 'text', key: 'jobWorkshop', label: '扶贫车间' },
        { type: 'text', key: 'jobPublicWelfare', label: '公益岗位' },
        { type: 'text', key: 'jobPioneer', label: '创业' },
        { type: 'text', key: 'jobOther', label: '其它' },
        
        { type: 'text', key: 'jobAreaCounty', label: '县内' },
        { type: 'text', key: 'jobAreaProvinceIn', label: '县外省内' },
        { type: 'text', key: 'jobAreaZhu3', label: '珠三角' },
        { type: 'text', key: 'jobAreaLong3', label: '长三角' },
        { type: 'text', key: 'jobAreaJJArea', label: '京津冀' },
        { type: 'text', key: 'jobAreaOutside', label: '境外' },
        { type: 'text', key: 'jobAreaOther', label: '其它' },
      ],
      formItems2: [
        { type: 'text', key: 'hiStudentHasJob', label: '高校毕业生已就业人员' },
        { type: 'text', key: 'hiStudentNoJobNoWish', label: '高校毕业生无就业意愿' },
        { type: 'text', key: 'hiStudentNoJobHaveWish', label: '高校毕业生有就业意向' },
        { type: 'text', key: 'soldierHasJob', label: '退役军人已就业人员' },
        { type: 'text', key: 'soldierNoJobNoWish', label: '退役军人无就业意愿' },
        { type: 'text', key: 'soldierNoJobHaveWish', label: '退役军人有就业意向' },
        { type: 'text', key: 'disableHasJob', label: '残疾人已就业人员' },
        { type: 'text', key: 'disableNoJobNoWish', label: '残疾人无就业意愿' },
        { type: 'text', key: 'disableNoJobHaveWish', label: '残疾人有就业意向' },
        { type: 'text', key: 'fishManHasJob', label: '退捕渔民已就业人员' },
        { type: 'text', key: 'fishManNoJobNoWish', label: '退捕渔民无就业意愿' },
        { type: 'text', key: 'fishManNoJobHaveWish', label: '退捕渔民有就业意向' },
        { type: 'text', key: 'lostJobHasJob', label: '其它失业人员已就业人员' },
        { type: 'text', key: 'lostJobNoJobNoWish', label: '其它失业人员无就业意愿' },
        { type: 'text', key: 'lostJobNoJobHaveWish', label: '其它失业人员有就业意向' },


        { type: 'text', key: 'lostSalary', label: '欠薪人数' },
        { type: 'text', key: 'dealLostSalary', label: '已处理' },
        { type: 'text', key: 'notDealLostSalary', label: '未处理' },
        { type: 'text', key: 'needPersons', label: '招聘人数' },
        { type: 'text', key: 'workPersons', label: '已招聘人数' },
        { type: 'text', key: 'emptyWorkPersons', label: '空岗人数' },
      ],
    }
  },
  methods: {
    getData(rD = {}) {
      this.$api.util_search(this.sign, rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c_R:`, 'color: #f00;', _R)
          this.tableData = _R
          // this.tableData = _R.map(x => {
          //   x.areaName = x.province + x.city + x.county + x.town + x.village
          //   return x
          // })
          this.pageData.total = res.data.size
        } else { this._status(res.data) }
      })
    },
  },
  created() {
    const powerList = this.userInfo.privilegesList
    const powerStr = powerMap[this.sign]
    // console.log(powerStr)
    this.btnShow.search = true
    const mapList = ['export']
    if (this.userInfo.admin) {
      mapList.forEach(x => {
        this.btnShow[x] = true
      })
    } else {
      mapList.forEach(x => {
        if (x && powerList.includes(powerStr + '-' + x)) {
          this.btnShow[x] = true
        }
      })
    }
  },
}
</script>

<style lang='scss' scoped>
.section-filter{display: flex;overflow-x: auto;}
.section-filter>div{flex-shrink: 0;}
.filter-col{display: flex;flex-direction: column;}
.filter-area{display: flex;}
.filter-area-label{margin:5px 10px 0 50px;font-size: 14px;}
.filter-btn{margin-left: 20px;}

.section-btns{padding-left: 15px;margin-right: 10px;display: flex;}
/deep/.section-btns .el-upload-list{display: none;}
</style>